import PageMeta from '@/components/PageMeta';
import SectionHeader from '@/components/SectionHeader';
import { Link } from 'react-router-dom';

const PARTNER_TYPES = [
  { t: 'Fitness platforms', b: 'Building credible movement feedback into existing fitness ecosystems.' },
  { t: 'Coaching companies', b: 'Augmenting human coaching with structured movement observations between sessions.' },
  { t: 'Sports organisations', b: 'Extending camera-based movement intelligence into athlete development contexts.' },
  { t: 'Allied-health platforms', b: 'Exploring how movement feedback might support remote and hybrid care models.' },
  { t: 'Rehabilitation services', b: 'Looking at how between-appointment support might be delivered at scale.' },
  { t: 'Research organisations', b: 'Collaborating on the long-term science of camera-based movement interpretation.' },
  { t: 'Movement-technology companies', b: 'Complementing wearable, sensor and clinic-room movement systems.' },
  { t: 'Strategic partners', b: 'Advisors, collaborators and investors aligned with the long-term mission.' },
];

export default function Partners() {
  return (
    <div>
      <PageMeta
        title="Partners"
        description="A broader platform for movement intelligence. Future SDK, API and integration partnerships."
      />
      <section className="vl-container py-16 lg:py-24">
        <p className="mono-label text-vl-violet">Partners</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mt-5 text-vl-ink max-w-3xl">
          A broader platform for movement intelligence.
        </h1>
        <p className="mt-6 text-lg text-vl-ink/70 max-w-2xl leading-relaxed">
          The first Valanti Labs application is one expression of a larger technology platform. We are open to careful
          conversations with organisations that share our long-term focus on honest, useful movement technology.
        </p>
      </section>

      <section className="bg-vl-bg2 border-y hairline">
        <div className="vl-container py-20 lg:py-28">
          <SectionHeader kicker="Open to conversations" title="The organisations we'd like to hear from." />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-4">
            {PARTNER_TYPES.map((p) => (
              <div key={p.t} className="rounded-3xl bg-vl-surface border hairline p-7 hover:shadow-md transition-shadow">
                <h3 className="font-serif-display text-2xl text-vl-ink">{p.t}</h3>
                <p className="text-sm text-vl-ink/70 mt-3 leading-relaxed">{p.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vl-container py-24 lg:py-32 max-w-3xl">
        <p className="mono-label text-vl-violet">Future directions</p>
        <h2 className="font-serif-display text-3xl text-vl-ink mt-4 leading-tight">
          SDK, API and platform integrations.
        </h2>
        <p className="mt-5 text-vl-ink/75 leading-relaxed">
          SDK licensing, API licensing, white-label applications, partner pilots and platform integrations are being
          explored as future directions. They are not currently available, and we will not promise a working SDK until
          one is formally ready.
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-full bg-vl-ink text-vl-bg px-6 py-3.5 text-sm font-medium hover:bg-vl-violet transition-colors"
          >
            Discuss a future pilot
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-full border border-vl-ink/20 text-vl-ink px-6 py-3.5 text-sm font-medium hover:bg-vl-ink/5 transition-colors"
          >
            Explore a technology partnership
          </Link>
        </div>
      </section>
    </div>
  );
}
